import { render, staticRenderFns } from "./_DriverStatus.vue?vue&type=template&id=0054e4ff&scoped=true&"
import script from "./_DriverStatus.vue?vue&type=script&lang=js&"
export * from "./_DriverStatus.vue?vue&type=script&lang=js&"
import style0 from "./_DriverStatus.vue?vue&type=style&index=0&id=0054e4ff&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0054e4ff",
  null
  
)

export default component.exports